import { Grid, Tab, Tabs } from "@mui/material";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import Overview from "./Overview";
import Users from "./Users";
import Product from "./Product";
import Revenue from "./Revenue";
import Preferences from "./Preferences";

const Details = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <DashboardLayout
      title="Details"
      breadcrumbs={[
        {
          name: "Details",
          path: "details",
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label="Details Tabs"
            sx={{
              width: "100%",
              borderBottom: 1,
              borderColor: "divider",
              backgroundColor: "#fff",
              mb: 2,
              ".MuiTabs-flexContainer": {
                justifyContent: "center",
              },
              ".MuiTab-root": {
                flex: 1,
              },
            }}
          >
            <Tab label="Overview" />
            <Tab label="Users" />
            <Tab label="Product" />
            <Tab label="Revenue" />
            <Tab label="Preferences" />
          </Tabs>
        </Grid>
        <Grid item xs={12}>
          <div style={{ padding: "16px" }}>
            {selectedTab === 0 && <Overview />}
            {selectedTab === 1 && <Users />}
            {selectedTab === 2 && <Product />}
            {selectedTab === 3 && <Revenue />}
            {selectedTab === 4 && <Preferences />}
          </div>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default Details;
